import React from "react";
import {SVGIcon} from "@instructure/ui";

export function AppIcon(props) {
    return <SVGIcon  viewBox="0 0 120 120" {...props}>
        <title id="title">LTI Integrations plug icon</title>
        <desc id="desc">Rounded square icon with a stylized plug, smooth wavy cable, and centered accent.</desc>

        <rect x="4" y="4" width="112" height="112" rx="18" ry="18" fill="#0f1724"/>

        <circle cx="60" cy="60" r="36" fill="#0b1220" opacity="0.6"/>

        <g transform="translate(22,26)">

            <path
                d="
        M0 60
        C15 50, 28 70, 38 56
        C48 42, 52 42, 44 34
        L44 32
      "
                fill="none"
                stroke="#7cc0ff"
                stroke-width="4"
                stroke-linecap="round"
                stroke-linejoin="round"
            />

            <rect x="32" y="10" width="48" height="36" rx="6" ry="6" fill="#e6eef8"/>

            <rect x="38" y="16" width="36" height="24" rx="4" ry="4" fill="#d1e6fb"/>

            <rect x="44" y="0" width="6" height="18" rx="1" ry="1" fill="#d1e6fb"/>
            <rect x="58" y="0" width="6" height="18" rx="1" ry="1" fill="#d1e6fb"/>

            <rect x="44" y="10" width="6" height="4" fill="#b6cfeb"/>
            <rect x="58" y="10" width="6" height="4" fill="#b6cfeb"/>

            <g transform="translate(56,28)"
               fill="none"
               stroke="#7cc0ff"
               stroke-width="2.4"
               stroke-linecap="round"
               stroke-linejoin="round">
                <circle cx="0" cy="0" r="7" />
                <path d="M3 -1 L6 -4 L2 -5" fill="#7cc0ff" stroke="#7cc0ff"/>
            </g>

        </g>
    </SVGIcon>
}